import React, { useState } from 'react'
import { ChangePasswordFormImport } from './Import'
const { RoutesMap, Button, Form, Password, useFormik, ButtonLoader, ChangePasswordSchema, useDispatch, toast, changePassword, useNavigate, toggleChangePasswordModal, useTranslation } = ChangePasswordFormImport

export default function ChangePasswordForm() {

    const [spinner, setSpinner] = useState(false)
    const [oldPassword, setOldPassword] = useState(false)
    const [newPassword, setNewPassword] = useState(false)
    const [confirmPassword, setConfirmPassword] = useState(false)
    const { t } = useTranslation()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const initialValues = {
        old_password: '',
        new_password: '',
        confirm_password: '',
    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues: initialValues,
        validationSchema: ChangePasswordSchema,
        enableReinitialize: true,

        onSubmit: (values, action) => {
            setSpinner(true)
            dispatch(changePassword(values)).then((res) => change_pwd_res(res.payload, action))
        },
    })

    const change_pwd_res = (res, action) => {

        if (res?.status === 200) {

            toast.success(t('changePass.success_add'), { position: "bottom-right" })
            dispatch(toggleChangePasswordModal())
            setSpinner(false)

        } else if (res?.status === 401) {
            navigate(RoutesMap.LOGIN.path)
            setSpinner(false)
        } else if (res?.status === 400) {
            toast.error(res?.data?.message, { position: "bottom-right" })
            setSpinner(false)
        } else if (res?.status === 500) {
            toast.error(t('changePass.server_error'), { position: "bottom-right" })
            setSpinner(false)
        } else {
            toast.error(t('changePass.wrong'), { position: "bottom-right" })
            setSpinner(false)
        }

    }

    return (
        <>
            <div className="container-fluid">
                <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} >
                    <div className="row">

                        <div className="col-lg-12">
                            <Password
                                label_name={t('changePass.old_pass')}
                                mandatory={true}
                                placeholder=''
                                disabled={false}
                                name='old_password'
                                value={values.old_password}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.old_password && touched.old_password ? (<span className='field_error'>{errors.old_password}</span>) : null}
                                showPassword={oldPassword}
                                setShowPassword={setOldPassword}
                            />
                        </div>

                        <div className="col-lg-12">
                            <Password
                                label_name={t('changePass.new_pass')}
                                mandatory={true}
                                placeholder=''
                                disabled={false}
                                name='new_password'
                                value={values.new_password}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.new_password && touched.new_password ? (<span className='field_error'>{errors.new_password}</span>) : null}
                                showPassword={newPassword}
                                setShowPassword={setNewPassword}
                            />
                        </div>

                        <div className="col-lg-12">
                            <Password
                                label_name={t('changePass.confirm_pass')}
                                mandatory={true}
                                placeholder=''
                                disabled={false}
                                name='confirm_password'
                                value={values.confirm_password}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.confirm_password && touched.confirm_password ? (<span className='field_error'>{errors.confirm_password}</span>) : null}
                                showPassword={confirmPassword}
                                setShowPassword={setConfirmPassword}
                            />
                        </div>

                        <div className="col-lg-12">
                            <Button type='submit' size='sm' className='login_btn mt-3' disabled={spinner} >
                                {spinner ?
                                    <ButtonLoader />
                                    :
                                    t('common.submit')
                                }
                            </Button>
                        </div>

                    </div>
                </Form>
            </div>
        </>
    )
}
